export default __webpack_public_path__ + "static/media/eamcs_bg_large.af95e67b.jpg";